import { featureFlagSlugs } from '@/constants/featureFlagSlugs';
import { useFeatureFlags } from '@/stores/useFeatureFlags';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import { storeToRefs } from 'pinia';

/**
 * Check if the user is able to access carrier profile based on their role and FF status
 */
async function useIsCarrierProfileEnabled() {
  const useFeatureFlagsStore = useFeatureFlags();
  const userDetailsStore = useUserDetailsStore();
  const { role } = storeToRefs(userDetailsStore);

  const isFlagEnabled = await useFeatureFlagsStore.fetchFlagByName(
    featureFlagSlugs.transportCarrierManageProfile
  );

  const acceptedRoles = new Set();

  acceptedRoles.add('admin').add('first').add('preferred').add('owner');

  const slug = computed(() => featureFlagSlugs.transportCarrierManageProfile);
  const isAllowedBasedOnRole = computed(() =>
    acceptedRoles.has(role?.value?.toLowerCase())
  );

  const isCarrierProfileEnabled = computed(
    () => isFlagEnabled && isAllowedBasedOnRole.value
  );

  return {
    slug,
    isCarrierProfileEnabled,
  };
}
export { useIsCarrierProfileEnabled };
